import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WorkService } from '../../services/work.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'edit-addworkreport',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class EditWorkreportComponent implements OnInit {
  
  isCollapsed = false;
  formData: any = {
    problem:"Không có vấn đề, công việc diễn ra tốt đẹp",
    suggestion: "Không có đề xuất hoặc kiến nghị"
  };
  perPage = 10;
  page = 1;
  dataCalendar:any = [];
  currentYear = new Date().getFullYear();
  yearSelect = new Date().getFullYear();
  weekSelect = null;
  calendarSelect: any = [];
  report: any = [];
  reportId: string;
  isLoading = false;
  editor1 = false;
  editor2 = false;
  editor3 = false;
  editor4 = false;
  editor5 = false;

  constructor(
    private workService: WorkService,
    private message: NzMessageService,
    public router:Router,
    private readonly routerLinkActive: ActivatedRoute,
  ) { }


  editReport(id:string, data:any){
    this.isLoading = true;
    this.workService.editReport(id, data).subscribe(
      res => {
        console.log('res', res);
        this.message.success('Cập nhập báo cáo thành công!')
        this.router.navigate(['/report']);
        this.isLoading = false;
      },
      err => {
        console.log('err', err);
        this.message.error('Không cập nhật báo cáo, vui lòng thử lại!')
        this.isLoading = false;
      }

    )
  }

  getReport(){
    this.routerLinkActive.paramMap.subscribe((params:any)=>{
      this.reportId = params.get('id');
      this.workService.getReportId(params.get('id')).subscribe(
        res => {
          this.report = res.data;                 
          this.formData.work_mow = res.data.work_mow;
          this.formData.work_this_week = res.data.work_this_week;
          this.formData.work_next_week = res.data.work_next_week;
          this.formData.problem = res.data.problem;
          this.formData.suggestion = res.data.suggestion;
          this.yearSelect = res.data.calendar.year;
          this.weekSelect = res.data.calendar.week;
        },
        err => {
          console.log('err', err);
        }  
      )
    })    
  }


  onSubmit() {    
    this.editReport(this.reportId ,this.formData);
  }
 
  ngOnInit() {
    this.getReport();
  }

}
